import { Box, Stack, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router";
// import { functions } from "../../../../Firebase";

const SendRemainderPopUp = (props) => {
  const {
    onClose,
    open,
    delfun,
    topicId,
    setConfirmation,
    count,
    calledFrom,
    dateForEmail,
    setDateForEmail,
  } = props;
  const handleClose = () => {
    onClose();
  };
  const [dueDate, setDueDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  useEffect(() => {
    setFirstnum(Math.floor(Math.random() * 10));
    setSecondnum(Math.floor(Math.random() * 10));
  }, [open]);
  const [loading, setLoading] = useState(false);
  const [mathDotRendom, setMathDotRendom] = useState(topicId);
  const [inputId, setInputId] = useState(0);
  const [firstnum, setFirstnum] = useState(Math.floor(Math.random() * 100));
  const [secondnum, setSecondnum] = useState(Math.floor(Math.random() * 100));
  const [employeeNameOpt, setEmployeeNameOpt] = useState(false);
  console.log("prop line 29", calledFrom);
  let navigater = useNavigate();
  const runGenerateCertificateTraining = (type) => {
    /// navigater("/admin/course-reports")
    console.log(employeeNameOpt);
    if (type == "Yes") {
      //console.log(topicId.id)
      //alert("sum is eqel");
      console.log("I CLICKED YES", employeeNameOpt);
      // delfun("Yes");
      if (employeeNameOpt || calledFrom == "form") {
        console.log("ifBlock");

        delfun("Yes", true);
      } else {
        console.log("elseBlock");
        delfun("No", false);
      }
      onClose();
    } else {
      onClose();
    }
  };

  return (
    <Dialog
      fullWidth={false}
      maxWidth="300px"
      PaperProps={{
        style: {
          borderRadius: "20px",
          padding: "24px",
          overflow: "auto",
          scrollbarWidth: "thin",
          scrollbarColor: "#6846C7 #444 !important",
          "&::-webkit-scrollbar": {
            width: "20px !important",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#444",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#6846C7 !important",
            borderRadius: "4px",
            width: "20px !important",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#555",
          },
        },
      }}
      onClose={() => {
        if (loading) return;
        handleClose();
      }}
      open={open}
    >
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            textAlign: "left",
            color: "#F3F1FF",
            overflowY: "auto",
          }}
        >
          <Typography
            sx={{
              marginLeft: `${!calledFrom ? 4 : 0}`,
              marginTop: 0,
              marginBottom: 2,
              color: "black",
            }}
          >
            {" "}
            Send {!calledFrom ? "Reminder" : "survey link"}
          </Typography>
          <button
            onClick={() => {
              if (loading) return;
              handleClose();
            }}
            style={{
              marginLeft: "auto",
              border: "none",
              background: "transparent",
            }}
          >
            <svg
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.43 0.244723C10.1145 -0.0707873 9.60485 -0.0707873 9.28934 0.244723L5.33333 4.19264L1.37732 0.236633C1.06181 -0.0788775 0.552143 -0.0788775 0.236633 0.236633C-0.0788775 0.552143 -0.0788775 1.06181 0.236633 1.37732L4.19264 5.33333L0.236633 9.28934C-0.0788775 9.60485 -0.0788775 10.1145 0.236633 10.43C0.552143 10.7455 1.06181 10.7455 1.37732 10.43L5.33333 6.47402L9.28934 10.43C9.60485 10.7455 10.1145 10.7455 10.43 10.43C10.7455 10.1145 10.7455 9.60485 10.43 9.28934L6.47402 5.33333L10.43 1.37732C10.7375 1.0699 10.7375 0.552143 10.43 0.244723Z"
                fill="#707EAE"
              />
            </svg>
          </button>
        </Box>
        {/* <LocalizationProvider> */}
        {/* <DateRangePickerDay /> */}
        {/* </LocalizationProvider> */}
        {!calledFrom && (
          <>
            <Typography color="#302F2F" sx={{ ml: 4 }}>
              The deadline for users to complete the course
            </Typography>
            <Typography sx={{ ml: 4, mb: 2, color: "#302F2F" }}>
              will be the below selected date.
            </Typography>
          </>
        )}
        {!calledFrom && (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateCalendar
              disablePast
              value={dateForEmail}
              onChange={(newValue) => {
                setDateForEmail(newValue);
              }}
              sx={{
                width: "300px", // Adjust width as needed
                height: "300px", // Adjust height as needed
                border: "1px solid #6846C7",
                borderRadius: "8px",
                paddingBottom: "18px",
                "& .MuiPickersCalendarHeader-root": {
                  marginTop: "8px",
                  marginBottom: "0px",
                },
                "& .MuiDayCalendar-header": {
                  marginTop: "4px",
                  marginBottom: "4px",
                },

                "& .MuiPickersDay-root": {
                  width: "32px",
                  height: "32px",
                  fontSize: "0.875rem",
                },
              }}
            />
          </LocalizationProvider>
        )}
        {!calledFrom && (
          <Typography sx={{ mt: 2, ml: 4, color: "#302F2F" }}>
            <Typography component="span" fontWeight="700">
              Deadline date :
            </Typography>{" "}
            {dayjs(dateForEmail).format("DD-MMM-YYYY")}
          </Typography>
        )}
        <Box
          sx={{
            // // mt: {!calledFrom"30px"},
            // !calledFrom && {
            //   mt: "30px",
            // },
            mt: `${calledFrom && "30px"}`,
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {/* <span>Do you want to send it ? </span> */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "10px",
                gap: "15px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <input
                  type="radio"
                  style={{
                    width: "1.375rem",
                    height: "1.375rem",
                    accentColor: "#5C22FF",
                  }}
                  value="empName"
                  onChange={() => {
                    setEmployeeNameOpt(true);
                  }}
                  checked={employeeNameOpt}
                />
                {!calledFrom && (
                  <p style={{ fontFamily: "Poppins", textAlign: "left" }}>
                    Send reminder to {count} employees.
                  </p>
                )}
                {calledFrom == "form" && <p>Do you want to send it ?</p>}
              </div>
              {!calledFrom && (
                <div
                  style={{
                    display: "flex",
                    gap: "10px",

                    alignItems: "center",
                  }}
                >
                  <input
                    type="radio"
                    style={{
                      width: "1.375rem",
                      height: "1.375rem",
                      accentColor: "#5C22FF",
                    }}
                    value="empEmail"
                    onChange={() => {
                      setEmployeeNameOpt(false);
                    }}
                    checked={!employeeNameOpt}
                  />
                  <label style={{ fontFamily: "Poppins", textAlign: "left" }}>
                    Send reminder to all employees with incomplete status.
                  </label>
                </div>
              )}
            </div>
          </div>

          <Stack
            direction="row"
            justifyContent="center"
            gap="20px"
            // style={{
            //   display: "flex",
            //   backgroundColor: "blue",
            //   justifyItems: "center",
            //   width: "100%",
            //   flexDirection: "row",
            //   alignItems: "center",
            //   gap: "20px",
            // }}
          >
            <Button
              sx={{
                color: "white",
                border: "1px solid #6846C7",
                padding: "5px 15px",
                width: "200px",
                backgroundColor: "#6846C7",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#6846C7",
                  border: "1px solid #6846C7",
                },
              }}
              disable={loading}
              onClick={() => {
                runGenerateCertificateTraining("Yes");
              }}
            >
              {loading ? "Loading..." : "Send"}
            </Button>

            <Button
              sx={{
                color: "#6846C7",
                border: "1px solid #6846C7",
                padding: "5px 15px",
                width: "200px",
              }}
              disable={loading}
              onClick={() => {
                runGenerateCertificateTraining("No");
              }}
            >
              {loading ? "Loading..." : "Cancel"}
            </Button>
          </Stack>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SendRemainderPopUp;
